// extracted by mini-css-extract-plugin
module.exports = {"bio-gallery":"BioGallery_bio-gallery__2Cx43","bio-gallery-container":"BioGallery_bio-gallery-container__vEb__","bio-gallery-item":"BioGallery_bio-gallery-item__glTiD"};